/**
 * Quem enxerga o assistente de IA.
 *
 * O assistente responde sobre normas e apreciações em geral, sem recorte de
 * projeto, e cada resposta custa token — então nem todo squad alcança. O admin
 * enxerga, como no resto do sistema.
 *
 * A lista é de exclusão de propósito: squad novo continua enxergando por
 * padrão. Para tirar alguém, acrescente o nome aqui e no `SQUADS_SEM_IA` do
 * backend (`ai.controller.ts`), que é quem barra de verdade.
 *
 * Vale só para o assistente (`/api/ai/chat` e `/api/ai/chat-normas`). A IA de
 * dentro da apreciação (gerar partes, encaixar fotos) segue liberada — faz
 * parte do fluxo de quem edita o documento.
 */
export const SQUADS_SEM_IA = ['India', 'Demo'];

export function podeAcessarIA(squadNome: string | null | undefined, isAdmin: boolean): boolean {
  if (isAdmin) return true;
  if (!squadNome) return true;
  return !SQUADS_SEM_IA.some((s) => s.toLowerCase() === squadNome.toLowerCase());
}
